import { supportGetStudent, supportSearchStudents } from '@repo/sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/query/query-keys'

// Both reads return students' personal data, so every fetch is one
// `personal_data.viewed` fact in the event log (decision D37). They keep the
// client defaults (no refetch when the window gets the focus, ten minutes
// before the data is stale): one opening is one access, not one per focus.
// `check-personal-data-queries.mjs` fails when a read of this kind loses that.

/** The students a search text points to; nothing is asked for an empty text. */
export function supportSearchQueryOptions(query: string) {
	return queryOptions({
		queryKey: makeQueryKeys.support.search(query),
		queryFn: ({ signal }) =>
			supportSearchStudents({ body: { query }, signal }),
		enabled: query.length > 0
	})
}

/** The card of support of one student. */
export function supportStudentQueryOptions(userId: string) {
	return queryOptions({
		queryKey: makeQueryKeys.support.student(userId),
		queryFn: async ({ signal }) =>
			(await supportGetStudent({ body: { data: { userId } }, signal }))
				.data
	})
}
